<template lang="pug">
#mapbox-container
  .hud
    .key
      .section
        h6 MOUSE LOCATION
        p LAT: {{ lat }}
        p LON: {{ lon }}
      hr(v-if="selection")
      .section(v-if="selection && selection.type === 'Polygon'")
        h6 POLYGON
        p SIMULATIONS: {{ selection.simulations }}
        p USERS: {{ selection.users }}
      .section(v-if="selection && selection.type === 'LineString'")
        h6 LINE
        p LENGTH: {{ selection.lineLength }} km
</template>

<script>
import axios from 'axios'
import mapboxgl from 'mapbox-gl'
import MapboxDraw from '@mapbox/mapbox-gl-draw'
import { getDistance } from 'geolib'

export default {
  name: 'WorldMap',
  data() {
    return {
      map: null,
      draw: null,
      states: null,
      lat: null,
      lon: null,
      selection: null
    }
  },
  mounted() {
    axios.get('/all_states.json')
    .then(res => {
      this.states = res.data
      this.createMap()
      this.createPoints()
      this.setEvents()
    })
  },
  methods: {
    createMap() {
      mapboxgl.accessToken = 'pk.eyJ1IjoiYWRyaWZ0LXByb2plY3QiLCJhIjoiY2pwOTN0N3B5MDNidTN2bWtieW9qbWFuNCJ9.swJnzFtuzQDne9z8iQ0JcQ'
      this.map = new mapboxgl.Map({
        container: 'mapbox-container',
        style: 'mapbox://styles/adrift-project/ck6j2knbs0x3u1ipetar3kc2a'
      })

      this.draw = new MapboxDraw({
        displayControlsDefault: false,
        controls: {
          line_string: true,
          polygon: true,
          trash: true
        }
      })
      this.map.addControl(this.draw, 'top-right')
    },

    createPoints() {
      this.map.on('load', () => {

        this.map.addSource('states', {
          'type': 'geojson',
          'data': this.states
        })

        this.map.addLayer({
          'id': 'photo-points',
          'type': 'circle',
          'source': 'states',
          'paint': {
            'circle-opacity': 0.5,
            'circle-radius': {
              'stops': [
                [1, 0.8],
                [10, 0.8],
                [15, 2]
              ]
            },
            'circle-color': '#ffffff'
          }
        }) // end add layer
      })
    },

    sanitiseCoordinates(c) {
      let lng = c.lng;
      if (c.lng < -180) lng = 180 + (c.lng + 180);
      if (c.lng > 180) lng = -180 + (c.lng - 180);

      let lat = c.lat;
      if (c.lat < -90) lat = 90 + (c.lat + 90);
      if (c.lat > 90) lat = -90 + (c.lat - 90);

      return {
        lng: lng,
        lat: lat
      }
    },

    setEvents() {
      this.map.on('mousemove', e => {
        let c = this.sanitiseCoordinates(e.lngLat)
        this.lat = c.lat.toFixed(6)
        this.lon = c.lng.toFixed(6)
      })

      this.map.on('draw.selectionchange', data => {
        if (data.features.length) { // if anything selected

          let selectedDrawing = data.features[0]
          if (selectedDrawing.geometry.type === 'Polygon') {

            let c = selectedDrawing.geometry.coordinates[0]
            let nw = this.map.project(c[0])
            // let ne = this.map.project(c[1])
            let se = this.map.project(c[2])
            // let sw = this.map.project(c[3])

            let capturedStates = this.map.queryRenderedFeatures([
              [nw.x, nw.y],
              [se.x, se.y]
            ], { layers: ['photo-points']})

            let uniqueSimIds = []
            capturedStates.forEach(state => {
              let sim_id = state.properties.sim_id
              if (!uniqueSimIds.includes(sim_id)) uniqueSimIds.push(sim_id)
            })

            let uniqueUserIds = []
            capturedStates.forEach(state => {
              let user_id = state.properties.user_id
              if (!uniqueUserIds.includes(user_id)) uniqueUserIds.push(user_id)
            })

            this.selection = {
              type: 'Polygon',
              simulations: uniqueSimIds.length,
              users: uniqueUserIds.length
            }

          } else { // if selectedDrawing.geometry.type === 'LineString'
            this.selection = {
              type: 'LineString',
              lineLength: this.measureLength(selectedDrawing)
            }

          }

        } else { // if nothing selected/deselect event
          this.selection = null
        }

      })
    },

    measureLength(feature) {
      let c = feature.geometry.coordinates
      let t = getDistance(
        { latitude: c[0][1], longitude: c[0][0] },
        { latitude: c[1][1], longitude: c[1][0] }
      )
      return t / 1000
    }


  }
}
</script>

<style lang="stylus" scoped>
#mapbox-container
  position fixed
  width 100%
  height 100%
  background-color black
  z-index 1

  .hud
    position absolute
    width 100%
    height 100%
    z-index 2
    pointer-events none

    .key
      font-family 'ISO v0.6' !important
      letter-spacing -0.02em
      line-height 1.2em
      position absolute
      bottom 1.5em
      left 1.5em
      color rgba(#ffffff, 1)
      // min-width 150px
      // min-height 100px
      background-color #020928
      border 1px solid rgba(#ffffff, 0.3)
      border-radius 3px
      padding 0.8em 1em 0.6em 1em
      min-width 160px
      box-sizing border-box
      z-index 3
      pointer-events all

      hr
        border 0
        background-color rgba(#ffffff, 0.3)
        height 1px
        margin-bottom 1em

      .section
        margin-bottom 1em
        &:last-child
          margin-bottom 0
        h6
          text-decoration underline
          margin-bottom 0.3em

</style>
